<template>
    <div class="m-prompt" :style="{'display': show ? 'block' : 'none'}">
        <div class="m-prompt-nr">
            <p>{{msg}}</p>
        </div>
    </div>
</template>

<script>
  export default {
    data () {
      return {
        show: false,
        msg: ''
      }
    },
    methods: {
      shows (val, interval) {
        if (!interval) {
          interval = 3000
        }
        this.msg = val
        this.show = true
        setTimeout(() => {
          this.show = false
        }, interval)
      }
    }
  }
</script>

<style scoped>
    .m-prompt {
        position: fixed;
        top: 25%;
        z-index: 9999;
        text-align: center;
        margin: 0 auto;
        width: 100%;
    }

    .m-prompt-nr {
        background-color: rgba(0, 0, 0, 0.7);
        /*background-color: #ece4de;*/
        border-radius: 5px;
        color: #fff;
        text-align: center;
        padding: 20px;
        margin: 0 10px;
        display: inline-block;
    }

    .m-prompt-nr img {
        width: 30px;
        margin-bottom: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/base/tips/tips.vue